<script>
  import { onMount } from "svelte";
  import QrCode from "svelte-qrcode";
  import { CodeSnippet, Tile } from "carbon-components-svelte";
  import { fetchWithSession } from "lib/util/fetchWithSession.js";

  let hostname = "";
  let apikey = "";

  onMount(() => {
    fetchWithSession(`/api/settings/apikey`)
      .then((res) => res.json())
      .then((data) => {
        apikey = data.apikey;
        hostname = data.hostname;
      });
  });
</script>

<div class="installation-instructions-content">
  <Tile light>
    <div class="installation-fields">
      <p>During the installation, provide the API address and API key:</p>
      <div class="installation-field">
        <span>API address</span>
        <CodeSnippet
          class="installation-code-snippet"
          code={hostname + "/data/"}
          aria-label="API address"
        />
      </div>
      <div class="installation-field">
        <span>API key</span>
        <CodeSnippet
          class="installation-code-snippet"
          type="multi"
          wrapText
          showMoreLess={false}
          code={apikey}
          aria-label="API key"
        />
      </div>
      <p>Or use the following code snippet to install silently from the command line:</p>
      <CodeSnippet
        class="installation-code-snippet"
        type="multi"
        wrapText
        showMoreLess={false}
        code={'msiexec /i paxray_installer_latest.msi /quiet APIKEY="' +
          apikey +
          '" APIURL="' +
          hostname +
          '/data/"'}
      ></CodeSnippet>
    </div>
  </Tile><br /><br />
  <!-- <Tile light>
    Get user input for blacklist and anonymization rules during the initial project workshop! <br><br>
    Share the link below with your workshop participants:
    <br><br><br>
    <CodeSnippet code={baseurl + "/UserInput?idproject="+idproject} ></CodeSnippet>
    <br><br><br>
    or show the following QR-Code during the session: <br><br>
    <div style="margin:0 auto; width:200px;">
     <QrCode value={baseurl + "/UserInput?idproject="+idproject}/>
    </div>
</Tile> -->
</div>

<style>
  .installation-instructions-content {
    width: 100%;
    max-width: 800px;
    box-sizing: border-box;
    margin: 0 auto;
  }

  .installation-fields,
  .installation-field {
    display: grid;
    gap: 1rem;
    min-width: 0;
  }

  :global(.installation-code-snippet) {
    box-sizing: border-box;
    max-width: 100%;
    min-width: 0;
  }

  p {
    margin: 0;
  }
</style>
